import React from "react";

import { useTheme } from "styled-components";

import Illustration from "Vendor_resources/images/empty-services.svg";
import IllustrationDark from "Vendor_resources/images/empty-services_dark.svg";

import * as S from "./EmptyTree.styles";

type EmptyTreeProps = {
  maxMessageWidth?: string;
};

const EmptyTree = ({
  children,
  maxMessageWidth
}: React.PropsWithChildren<EmptyTreeProps>) => {
  const theme = useTheme();

  return (
    <S.EmptyTree id="empty-tree" data-testid="empty-tree">
      <S.Image>
        <img
          src={theme.name === "dark" ? IllustrationDark : Illustration}
          id="empty-services"
          alt="Empty services"
        />
      </S.Image>

      <S.Message maxWidth={maxMessageWidth}>{children}</S.Message>
    </S.EmptyTree>
  );
};

export default EmptyTree;
